import React from 'react';
import { useParams } from 'react-router-dom';
import { Square, Flex, Loader, Stack } from '@grubhubprod/gh-cookbook-react';
import { IErrorResponse } from 'src/utilities/shared-types';
import {
  SdkErrorResponse,
  pushErrorFromAPI,
} from 'src/utilities/notifications';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { CorporateFieldsProvider } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/CorporateFieldsProvider';
import { CorporateForm } from 'src/components/enterprise/features/Corporate/components/Form/CorporateForm';
import { useCorporateEditPage } from 'src/components/enterprise/features/Corporate/EditPage/hooks/useCorporateEditPage';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { getWindow } from 'src/utilities/window';

export const ParentCorpEditPage: React.FC = () => {
  const { corpid: corpId } = useParams<{ corpid: string }>();
  const onSuccess = async (): Promise<void> => {
    const window = getWindow();
    window.location.href = `${window.location.origin}/groupadmin/parents/${corpId}`;
  };
  const onError = async (
    error: IErrorResponse | SdkErrorResponse
  ): Promise<void> => {
    pushErrorFromAPI(error);
  };
  const { corpData, corpFormValues, updateCorp, getCorpLoading, getCorpError } =
    useCorporateEditPage({
      corpId,
      onSuccess,
      onError,
    });

  if (getCorpError) {
    return null;
  }

  const isEditPage = Boolean(corpId);

  const editDescription =
    'Edits made to the parent account will be applied to all newly created child accounts.';

  return (
    <Square inset="lg">
      <PageHeader>
        <PageTitle title="Edit Parent Account" />
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Parent accounts',
              href: `/groupadmin/parents`,
            },
            {
              label: 'Details',
              href: `/groupadmin/parents/${corpId}`,
            },
          ]}
        />
      </PageHeader>
      <Stack y="sm">{editDescription}</Stack>
      {getCorpLoading ? (
        <Flex justifyContent="center">
          <Loader size="lg" />
        </Flex>
      ) : (
        <CorporateFieldsProvider>
          <CorporateForm
            corpData={corpData}
            defaultValues={corpFormValues}
            onSubmit={updateCorp}
            isEditPage={isEditPage}
          />
        </CorporateFieldsProvider>
      )}
    </Square>
  );
};
